import { SVG_CHECKMARK_OUTLINED } from '@getgo/chameleon-icons';
import { html } from '@microsoft/fast-element';
import { MenuItem, menuItemTemplate as template } from '@microsoft/fast-foundation';
import { MenuItemComponent } from './MenuItem';
import styles from './MenuItem.styles.scss';
import { withStylePrefix } from '../../common/withStylePrefix';
export const menuItemDefinition = {
    baseName: 'menu-item',
    baseClass: MenuItem,
    template: template,
    styles: withStylePrefix(styles),
    attributes: ['disabled', 'size'],
    radioIndicator: ((element) => {
        const svgTag = element.tagFor('svg');
        return html `<${svgTag}>${SVG_CHECKMARK_OUTLINED}</${svgTag}>`;
    }),
};
/**
 * NOTE:
 *
 * Depends on `AnchoredRegion` in a hidden way, for detailed information see {@link chameleonAnchorRegion}
 */
export const chameleonMenuItem = MenuItemComponent.compose(menuItemDefinition);
